<template>
  <v-container class="pd16">
    <strong class="t-cont-title">렌트프리 조회</strong>
    <p class="rf-notice">계약에 적용된 렌트프리 내역입니다.</p>

    <div class="rf-loading" v-if="loading">
      <v-progress-circular indeterminate color="#ef761d" size="28" />
      <p>렌트프리 내역을 불러오는 중입니다...</p>
    </div>

    <div class="rf-list" v-else-if="rentFrees.length">
      <table
        class="t-table table1"
        v-for="(rentFree, i) in rentFrees"
        :key="rentFreeKey(rentFree, i)"
      >
        <colgroup>
          <col width="110px" />
          <col width="*" />
        </colgroup>
        <tr>
          <th>산정구분</th>
          <td>{{ dash(rentFree.type) }}</td>
        </tr>
        <tr>
          <th>적용기간</th>
          <td>{{ periodLabel(rentFree) }}</td>
        </tr>
      </table>
    </div>

    <strong class="t-cont-title text-center mt-10" v-else>{{
      emptyMessage
    }}</strong>
  </v-container>
</template>

<script>
import { getRentFreeInfo } from "@/api/contract.js";

export default {
  name: "RentFreeList",
  data() {
    return {
      rentFrees: [],
      loading: false,
      emptyMessage: "조회된 렌트프리 내역이 없습니다.",
    };
  },
  computed: {
    home() {
      return this.$store.getters.getHome;
    },
  },
  methods: {
    dash(val) {
      return val === null || val === undefined || val === "" ? "-" : val;
    },
    formatDate(dt) {
      if (!dt) return "";
      if (dt.length !== 8) return dt;
      return `${dt.slice(0, 4)}-${dt.slice(4, 6)}-${dt.slice(6, 8)}`;
    },
    periodLabel(rentFree) {
      const start = this.formatDate(rentFree.start_date);
      const end = this.formatDate(rentFree.end_date);

      if (!start && !end) return "-";
      if (!end) return start;
      if (!start) return end;

      return `${start} ~ ${end}`;
    },
    rentFreeKey(rentFree, i) {
      return `${rentFree.seq || "rent-free"}-${i}`;
    },
    getRentFrees() {
      this.loading = true;

      getRentFreeInfo(this.home.id)
        .then((result) => {
          this.rentFrees = result.data;
        })
        .catch((_) => {
          this.rentFrees = [];
          this.emptyMessage = "렌트프리 내역을 조회할 수 없습니다.";
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getRentFrees();
  },
};
</script>

<style scoped>
.rf-notice {
  margin: 0 0 12px;
  text-align: left;
  font-size: 12px;
  line-height: 18px;
  color: #909090;
}

.rf-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 32px 0;
}

.rf-loading p {
  margin: 0;
  color: #444444;
  font-size: 14px;
}

.rf-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* 항목 간격은 gap으로만 두고 전역 .t-table 하단 여백(28px)은 제거 */
.rf-list .t-table {
  margin-bottom: 0;
}

/* 건과 건 사이 구분선 */
.rf-list .t-table + .t-table tr:first-child > * {
  border-top: 1px solid #e5e5e5;
  padding-top: 10px;
}
</style>
